import React from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import ProduttivoMuiTheme from '@/javascript/presentation/theme/produttivo-mui-theme'
import { AiTicketSuggestion } from '@/javascript/presentation/pages/tickets/components'
import { makeRemoteLoadNewTicketSuggestion } from '../../usecases'

const ticketSuggestionEl = document.getElementById('ai-assist-ticket-suggestion-button')

export const makeAiTicketSuggestion = () => {
  const hasAiAssist = ticketSuggestionEl.getAttribute('data-ai-assist') === 'true'
  return(
  <ThemeProvider theme={ProduttivoMuiTheme}>
    <AiTicketSuggestion
      loadNewTicketSuggestion={makeRemoteLoadNewTicketSuggestion()}
      contracted={hasAiAssist}
    />
  </ThemeProvider>
  )
}

if (ticketSuggestionEl !== null) {
  const root = createRoot(ticketSuggestionEl)
  root.render(makeAiTicketSuggestion())
}
